var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import { mapState } from 'vuex';
import { toYuan } from '../../../utils/unit-conversion';
import eventBus from '../../../utils/fresh-table';
import filterCondition from './filter-condition.vue';
import pagination from '../../console-common/pagination.vue';
import tableExpand from '../../console-common/table-expand.vue';
import listExpend from './list-expend.vue';
import terminalOrder from './dialog-terminal-order.vue';
import manualCollection from './dialog-manual-collection.vue';
import appendix from './dialog-appendix.vue';
export default Vue.extend({
    name: 'fundLoanOrderList',
    components: {
        'custom-filter-condition': filterCondition,
        'custom-pagination': pagination,
        'el-table-expand': tableExpand,
        'el-list-expend': listExpend,
        'el-terminal-order': terminalOrder,
        'el-manual-collection': manualCollection,
        'el-appendix': appendix,
    },
    computed: __assign({}, mapState('fundLoanManage', {
        loanOrderList: 'loanOrderList',
        totalItemCount: 'totalItemCount',
        pageSize: 'pageSize',
        pageNo: 'pageNo',
    })),
    data: function () {
        var _this = this;
        return {
            requestParam: {},
            dialogVisible: false,
            dialogConfig: {
                width: '',
                dialogTitle: '',
                flag: '',
            },
            tableDataConfig: [
                {
                    label: '线下合同号',
                    prop: 'contractCode',
                    minWidth: '110px',
                },
                {
                    label: '商户名称',
                    prop: 'tenantName',
                    tooltip: true,
                    minWidth: '225px',
                },
                {
                    label: '代扣协议',
                    prop: 'signStatus',
                    minWidth: '80px',
                    formatter: function (current) {
                        var capitalSignStatus = {
                            NOT_SEND: '未发送',
                            NOT_SIGN: '未签署',
                            SIGNED: '已签署',
                        };
                        return current ? capitalSignStatus[current] : '--';
                    },
                },
                {
                    label: '订单状态',
                    prop: 'status',
                    minWidth: '120px',
                    slotName: 'orderStatus',
                    formatter: function (current) {
                        var orderStatus = {
                            NORMAL: '正常',
                            OVERDUE: '已逾期',
                            PAID_OFF: '已还清',
                            TERMINAL: '已终止',
                        };
                        return current ? orderStatus[current] : '--';
                    },
                },
                {
                    label: '扣款总周期',
                    prop: 'dateRange',
                    minWidth: '210px',
                    formatter: function (current, row) {
                        var startTime = row.startTime
                            ? moment(row.startTime).format('YYYY-MM-DD')
                            : '--';
                        var endTime = row.endTime
                            ? moment(row.endTime).format('YYYY-MM-DD')
                            : '--';
                        return startTime + " \u81F3 " + endTime;
                    },
                },
                {
                    label: '放款总金额（元）',
                    prop: 'totalAmount',
                    align: 'right',
                    minWidth: '130px',
                    formatter: function (current) {
                        return current ? toYuan(current).toFixed(2) : '--';
                    },
                },
                {
                    label: '期数',
                    prop: 'totalDuration',
                    minWidth: '70px',
                },
                {
                    label: '操作',
                    prop: 'opt',
                    buttons: [
                        {
                            label: '终止',
                            callback: function (row) {
                                _this.updateDialogConfig({
                                    dialogConfig: {
                                        dialogTitle: '终止放款订单',
                                        flag: 'terminal',
                                        width: '460px',
                                        data: row,
                                    },
                                    dialogVisible: true,
                                });
                            },
                            style: {
                                color: '#FF5257',
                            },
                            formatter: function (row) {
                                var status = row.status;
                                if (status === 'NORMAL') {
                                    return true;
                                }
                                return false;
                            },
                        },
                    ],
                },
            ],
        };
    },
    watch: {
        requestParam: {
            deep: true,
            handler: function (val) {
                this.getData(val);
            },
        },
    },
    created: function () {
        this.getData({});
        eventBus.$on('freshTable', this.getData);
    },
    methods: {
        getParam: function (param) {
            this.requestParam = Object.assign({}, param);
        },
        getPageMsg: function (pageMsg) {
            this.requestParam = Object.assign({}, this.requestParam, pageMsg);
        },
        getData: function (param) {
            if (param === void 0) { param = {}; }
            this.$store.dispatch('fundLoanManage/GET_ORDERLIST', param);
        },
        cancleDialog: function () {
            this.updateDialogConfig({
                dialogConfig: {
                    dialogTitle: '',
                    flag: '',
                    width: '',
                    data: {},
                },
                dialogVisible: false,
            });
        },
        updateDialogConfig: function (config) {
            var dialogConfig = config.dialogConfig, dialogVisible = config.dialogVisible;
            this.dialogConfig = dialogConfig;
            this.dialogVisible = dialogVisible;
        },
    },
});
